export default "__VITE_PUBLIC_ASSET__5fbef23a__"